import { artists } from "@/constants/artists/artists";
import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";

export const isArtistTypeGuard = (
  artistMaybe: Artist | Instrument | ModelNoDates | MixedModelConstructedNoDates
): artistMaybe is Artist => {
  const artistIds = artists.map((artist) => artist.id);

  return artistIds.includes(artistMaybe.id);
};
